// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/images/baloa-background-login.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signup-claim-account-options__container {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: auto;
    gap: var( --grid-gap );
    grid-template-areas: "left left left left right right right right right right right right";
    background-color: var( --white-color );
    height: 150vh;
}

.signup-claim-account-options__container__left-col {
    grid-area: left;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    height: 150vh;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}

.signup-claim-account-options__container__left-col img {
    width: 180px;
    margin-top: 68px;
    margin-left: 48px;
}

.signup-claim-account-options__container__right-col {
    grid-column: 7 / 11;
    margin-top: 175px;
}

.signup-claim-account-options__buttons {
    display: flex;
    justify-content: flex-end;
    margin: calc( var( --space-x2 ) + var( --space-quarter ) ) 0 calc( var( --space-x3 ) + var( --space-x2 ) ) 0;
}

.signup-claim-account-options__container__right-col__title {
    display: flex;
    align-items: center;
}

.signup-claim-account-options__container__right-col__title .icon-arrow-left {
    margin-right: var(--space-x2);
    cursor: pointer;
}

.signup-claim-account-options__text.baloa-subtitle-2 {
    color: var(--primary-very-dark-color);
    margin-top: 36px;
    margin-bottom: 8px;
}

.signup-claim-account-options__options {
    width: 100%;
}

.signup-claim-account-options__options .MuiFormControlLabel-root {
    width: 100%;
    justify-content: space-between;
    border: 1px solid var( --new-line-color);
    border-radius: 8px;
    margin-top: 16px;
}

.signup-claim-account-options__options .MuiFormControlLabel-root.selected {
    border: 1px solid var( --new-green-color);
}

.signup-claim-account-options__options .MuiFormControlLabel-labelPlacementStart {
    margin-left: 0;
    margin-right: 0;
    padding: 12px 14px;
}

.signup-claim-account-options__options__option-text {
    display: flex;
    align-items: center;
}

.signup-claim-account-options__options__option-data {
    display: block;
}

.signup-claim-account-options__options__option-data .baloa-names {
    font-weight: var( --font-regular );
    color: var( --primary-dark-color );
}

.signup-claim-account-options__options__option-text .hubicon-phone,
.signup-claim-account-options__options__option-text .icon-email {
    margin-right: 10px;
    color: var( --primary-dark-color );
    font-size: 24px;
}

.signup-claim-account-options__recaptcha {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    zoom: 75%;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .signup-claim-account-options__container {
        display: block;
        height: 100vh;
    } 
    .signup-claim-account-options__container__left-col {
        height: 0;
        background-image: none;
    }
    .signup-claim-account-options__container__left-col a {
        display: flex;
        justify-content: center;
    }
    .signup-claim-account-options__container__left-col img {
        width: 100px;
        margin-top: calc( var(--space-x3) + var(--space-quarter) + var(--space-eighth) );
        margin-left: 0;
    }
    .signup-claim-account-options__container__right-col {
        margin-top: 112px;
    }
    .signup-claim-account-options__container__right-col__title {
        margin-left: var(--space);
    }

    .signup-claim-account-options__text {
        margin: 0 12px;
    }

    .signup-claim-account-options__options {
        margin-left: 12px;
        margin-right: 12px;   
        width: -webkit-fill-available;
    }

    .signup-claim-account-options__buttons {
        padding: 12px;
        bottom: 0;
        position: absolute;
        width: -webkit-fill-available;
        display: block;
        border-top: 1px solid var(--new-gray-background-color);
        margin: unset;
    }

    .signup-claim-account-options__buttons__forward {
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/authentication/components/signup-claim-account-options/SignUpClaimAccountOptionsComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sCAAsC;IACtC,wBAAwB;IACxB,sBAAsB;IACtB,0FAA0F;IAC1F,sCAAsC;IACtC,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,yDAA6E;IAC7E,aAAa;IACb,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,4GAA4G;AAChH;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,qCAAqC;IACrC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,8BAA8B;IAC9B,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,kCAAkC;AACtC;;AAEA;;IAEI,kBAAkB;IAClB,kCAAkC;IAClC,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,cAAc;QACd,aAAa;IACjB;IACA;QACI,SAAS;QACT,sBAAsB;IAC1B;IACA;QACI,aAAa;QACb,uBAAuB;IAC3B;IACA;QACI,YAAY;QACZ,gFAAgF;QAChF,cAAc;IAClB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,yBAAyB;IAC7B;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;QAClB,6BAA6B;IACjC;;IAEA;QACI,aAAa;QACb,SAAS;QACT,kBAAkB;QAClB,6BAA6B;QAC7B,cAAc;QACd,sDAAsD;QACtD,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[".signup-claim-account-options__container {\n    display: grid;\n    grid-template-columns: repeat(12, 1fr);\n    grid-template-rows: auto;\n    gap: var( --grid-gap );\n    grid-template-areas: \"left left left left right right right right right right right right\";\n    background-color: var( --white-color );\n    height: 150vh;\n}\n\n.signup-claim-account-options__container__left-col {\n    grid-area: left;\n    background-image: url(\"../../../../assets/images/baloa-background-login.png\");\n    height: 150vh;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.signup-claim-account-options__container__left-col img {\n    width: 180px;\n    margin-top: 68px;\n    margin-left: 48px;\n}\n\n.signup-claim-account-options__container__right-col {\n    grid-column: 7 / 11;\n    margin-top: 175px;\n}\n\n.signup-claim-account-options__buttons {\n    display: flex;\n    justify-content: flex-end;\n    margin: calc( var( --space-x2 ) + var( --space-quarter ) ) 0 calc( var( --space-x3 ) + var( --space-x2 ) ) 0;\n}\n\n.signup-claim-account-options__container__right-col__title {\n    display: flex;\n    align-items: center;\n}\n\n.signup-claim-account-options__container__right-col__title .icon-arrow-left {\n    margin-right: var(--space-x2);\n    cursor: pointer;\n}\n\n.signup-claim-account-options__text.baloa-subtitle-2 {\n    color: var(--primary-very-dark-color);\n    margin-top: 36px;\n    margin-bottom: 8px;\n}\n\n.signup-claim-account-options__options {\n    width: 100%;\n}\n\n.signup-claim-account-options__options .MuiFormControlLabel-root {\n    width: 100%;\n    justify-content: space-between;\n    border: 1px solid var( --new-line-color);\n    border-radius: 8px;\n    margin-top: 16px;\n}\n\n.signup-claim-account-options__options .MuiFormControlLabel-root.selected {\n    border: 1px solid var( --new-green-color);\n}\n\n.signup-claim-account-options__options .MuiFormControlLabel-labelPlacementStart {\n    margin-left: 0;\n    margin-right: 0;\n    padding: 12px 14px;\n}\n\n.signup-claim-account-options__options__option-text {\n    display: flex;\n    align-items: center;\n}\n\n.signup-claim-account-options__options__option-data {\n    display: block;\n}\n\n.signup-claim-account-options__options__option-data .baloa-names {\n    font-weight: var( --font-regular );\n    color: var( --primary-dark-color );\n}\n\n.signup-claim-account-options__options__option-text .hubicon-phone,\n.signup-claim-account-options__options__option-text .icon-email {\n    margin-right: 10px;\n    color: var( --primary-dark-color );\n    font-size: 24px;\n}\n\n.signup-claim-account-options__recaptcha {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    zoom: 75%;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .signup-claim-account-options__container {\n        display: block;\n        height: 100vh;\n    } \n    .signup-claim-account-options__container__left-col {\n        height: 0;\n        background-image: none;\n    }\n    .signup-claim-account-options__container__left-col a {\n        display: flex;\n        justify-content: center;\n    }\n    .signup-claim-account-options__container__left-col img {\n        width: 100px;\n        margin-top: calc( var(--space-x3) + var(--space-quarter) + var(--space-eighth) );\n        margin-left: 0;\n    }\n    .signup-claim-account-options__container__right-col {\n        margin-top: 112px;\n    }\n    .signup-claim-account-options__container__right-col__title {\n        margin-left: var(--space);\n    }\n\n    .signup-claim-account-options__text {\n        margin: 0 12px;\n    }\n\n    .signup-claim-account-options__options {\n        margin-left: 12px;\n        margin-right: 12px;   \n        width: -webkit-fill-available;\n    }\n\n    .signup-claim-account-options__buttons {\n        padding: 12px;\n        bottom: 0;\n        position: absolute;\n        width: -webkit-fill-available;\n        display: block;\n        border-top: 1px solid var(--new-gray-background-color);\n        margin: unset;\n    }\n\n    .signup-claim-account-options__buttons__forward {\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
